import {CommonModule} from '@angular/common';
import {ModuleWithProviders, NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {BreadcrumbsComponent} from './breadcrumbs.component';
import {BreadcrumbsService} from './breadcrumbs.service';

@NgModule({
    imports: [
        CommonModule,
        RouterModule
    ],
    declarations: [
        BreadcrumbsComponent
    ],
    exports: [
        BreadcrumbsComponent
    ]
})
export class BreadcrumbsModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: BreadcrumbsModule,
            providers: [
                BreadcrumbsService
            ]
        };
    }
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/shared/components/breadcrumbs/breadcrumbs.module.ts